/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

interface StepItemProps {
  stepNumber: number;
  title: string;
  actionText: string;
  onClick: () => void;
}

const StepItem: React.FC<StepItemProps> = ({ stepNumber, title, actionText, onClick }) => {
  const isReviewStep = actionText === 'Rever';

  return (
    <div className="bg-white rounded shadow-sm mb-2 p-2 d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center">
        <span
          className={`badge ml-2 mr-2 d-flex align-items-center justify-content-center ${
            isReviewStep ? 'check-success' : ''
          }`}
          style={{
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            fontSize: '14px',
          }}
        >
          {isReviewStep ? (
            <i className="material-icons step-icon" style={{ fontSize: '16px', color: '#fff' }}>
              check
            </i>
          ) : (
            stepNumber
          )}
        </span>
        {title}
      </div>
      {stepNumber === 1 ? (
        <a className="btn btn-link" href="/curso" role="button">
          {actionText}
        </a>
      ) : (
        <button type="button" className="btn btn-link" onClick={onClick}>
          {actionText}
        </button>
      )}
    </div>
  );
};

export default StepItem;
